import React from 'react'

export const SafetyTip = () => {
  return (
    <div className="flex flex-col ">
      <p className="text-left text-[20px] mb-10 ">
        5분 정도{' '}
        <span className="text-main font-bold">사용자님의 목소리 녹음</span>을
        진행하려고 하니, 여유로운 시간을 만들어주세요!
      </p>
      <div className="flex justify-center gap-10">
        <div className="flex flex-col w-[262px] gap-[10px]">
          <img
            src="assets/img/man.png"
            className="w-[262px] h-[218px] "
            alt=""
          />
          <div className="flex flex-col text-left gap-[10px]">
            <p className="font-bold">🤫 조용한 공간에서 녹음해주세요!</p>
            <p className="text-left">
              주변 소음이 함께 녹음되면
              <br />
              생성된 내 목소리의 품질이 떨어집니다.
            </p>
          </div>
        </div>
        <div className="flex flex-col w-[262px] gap-[10px]">
          <img
            src="assets/img/woman.png"
            className="w-[262px] h-[218px] "
            alt=""
          />
          <div className="flex flex-col text-left gap-[10px]">
            <p className="font-bold">🥰 목소리에 성격을 담아보세요!</p>
            <p className="text-left">
              밝고 친절한 성격, 진지하고 믿음직스러운 성격 등 만들고 싶은
              목소리의 캐릭터를 생각하며 녹음해주세요.
            </p>
          </div>
        </div>
      </div>
    </div>
  )
}
